module.exports = __webpack_public_path__ + "img/item-info-icon4_2.930b4de8.svg";